"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormGroup = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcFormGroup = function (props) {
    var label = props.label, value = props.value, 
    // @ts-ignore
    values = props.values, placeholder = props.placeholder, 
    // @ts-ignore
    type = props.type, 
    // @ts-ignore
    inline = props.inline, plaintext = props.plaintext, readonly = props.readonly, controlId = props.controlId, onChange = props.onChange, onClick = props.onClick, error = props.error;
    var _onChange = function (e) {
        if (onChange != undefined) {
            onChange(e.target.id, e.target.value);
        }
    };
    var GenerateFormControl = function () {
        if (type != undefined) {
            return (react_1.default.createElement("div", { key: inline ? "inline-" + type : "custom-single-" + type, className: "my-2", onClick: onClick }, values.map(function (val, index) { return (react_1.default.createElement(react_bootstrap_1.Form.Check, { id: "form-" + type + "-" + val.value + "-" + label, custom: true, disabled: val.disabled ? val.disabled : false, type: type, name: label, inline: inline, label: val.label, key: index, checked: val.checked, onChange: function () { return void 0; } })); })));
        }
        return (react_1.default.createElement(react_bootstrap_1.Form.Control, { onClick: onClick, onChange: _onChange, placeholder: placeholder, plaintext: plaintext, readOnly: readonly, defaultValue: value || '' }));
    };
    // @ts-ignore
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: controlId },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(GenerateFormControl, null),
        props.children));
};
exports.AcFormGroup = AcFormGroup;
exports.default = AcFormGroup;
AcFormGroup.displayName = 'AcFormGroup';
//# sourceMappingURL=AcFormGroup.js.map